

export function tinyId() {
  return Math.random().toString(16).substr(2);
}
